export default __webpack_public_path__ + "static/media/element_34.d0ce62b3.jpg";